// @ts-nocheck
import { DateTime } from "luxon";
import { formatTimeUnits } from "./formatters";
import {
  compactAMPMTimeRegex,
  dateRegex2,
  dateRegex3,
  meridianHoursRegex,
} from "../constants/dateRegex";
import dayjs from "dayjs";

const getFormattedTimeUnit = (time) => {
  const timeInInt = parseInt(time);
  if (timeInInt <= 9) return `0${timeInInt}`;
  else return `${timeInInt}`;
};

const getUTCTimestampFromDate = (date) => {
  const dt = new Date(date);
  const utcDate = new Date(
    dt.getUTCFullYear(),
    dt.getUTCMonth(),
    dt.getUTCDate(),
    dt.getUTCHours(),
    dt.getUTCMinutes(),
    dt.getUTCSeconds(),
  );
  const utcTimestamp = utcDate?.getTime();
  return utcTimestamp;
};

const formatAMPM = (date) => {
  let hours;
  let minutes;
  if (typeof date === "string") {
    const dateStr = date;
    const splittedDate = dateStr?.split("T")?.[1];
    hours = splittedDate?.split(":")?.[0];
    minutes = splittedDate?.split(":")?.[1];
  } else {
    hours = date.getHours();
    minutes = date.getMinutes();
    minutes = minutes < 10 ? "0" + minutes : minutes;
  }
  let ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  let strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
};

const getFullDateWithTime = (date) => {
  const dateOfMonth = date?.getDate();
  const month = date?.getMonth() + 1;
  const year = date?.getFullYear();

  return `${dateOfMonth}-${month}-${year} ${formatAMPM(date)}`;
};

const getFullDate = (date) => {
  let dateOfMonth;
  let month;
  let year;
  if (typeof date === "string") {
    const dateSplitted = date?.split("T")?.[0];
    dateOfMonth = dateSplitted?.split("-")?.[0];
    month = dateSplitted?.split("-")?.[1];
    year = dateSplitted?.split("-")?.[2];
  } else {
    dateOfMonth = date?.getDate();
    month = date?.getMonth() + 1;
    year = date?.getFullYear();
  }

  return `${dateOfMonth}-${month}-${year}`;
};

const createDateFromDateString = (dateStr) => {
  // dateStr should be in the form: "dd/mm/yyyy"
  if (!dateStr) {
    return null;
  }

  const dateSplitted = dateStr?.split?.("/");
  const day = dateSplitted?.[0];
  const month = dateSplitted?.[1];
  const year = dateSplitted?.[2];

  const dtObj = new Date();
  dtObj?.setDate(day);
  dtObj?.setMonth(month - 1);
  dtObj?.setFullYear(year);

  return dtObj;
};

const getFormattedFullDate = (date) => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let dateOfMonth;
  let month;
  let year;
  if (typeof date === "string") {
    const splittedDate = date?.split("T")?.[0];
    year = parseInt(splittedDate?.split("-")?.[0]);
    month = parseInt(splittedDate?.split("-")?.[1]) - 1;
    dateOfMonth = parseInt(splittedDate?.split("-")?.[2]);
  } else {
    dateOfMonth = date?.getDate();
    month = date?.getMonth();
    year = date?.getFullYear();
  }

  return `${dateOfMonth} ${months[month]}, ${year}`;
};

// const convertFromGivenTimezoneToUTC = ({
//     date,
//     timezone
// }) => {
//     // // Parse time string to Date object
//     // const dt = new Date(date);

//     // // Get the time zone offset in minutes
//     // const offset = dt.getTimezoneOffset();

//     // // Convert offset to milliseconds and add/subtract to get UTC time
//     // const utcTime = new Date(dt.getTime() + (offset * 60 * 1000));

//     // return utcTime.toISOString();
// }

function convertFromGivenTimezoneToUTC({ date, timezone, dateStr }) {
  // Parse the local time as being in the specified timezone
  let localDateTime = DateTime.fromISO(date, { zone: timezone });

  // If a custom dateStr is provided, replace the date part
  if (dateStr) {
    const [year, month, day] = dateStr.split("-").map(Number);
    localDateTime = localDateTime.set({ year, month, day });
  }

  // Convert the time to UTC
  const utcDateTime = localDateTime.toUTC();

  // Return the UTC time in ISO format
  return utcDateTime.toISO();
}

const convertFromUTCToGivenTimezone = ({ dateStr, timezone }) => {
  let returnVal = "";
  // Parse the UTC time
  const utcDateTime = DateTime.fromISO(dateStr, { zone: "UTC" });

  // Convert the UTC time to the specified timezone
  const localDateTime = utcDateTime.setZone(timezone);

  // Return the local time in ISO format with the appropriate local timezone offset
  const splittedDate = localDateTime?.toISO()?.split("T");

  const time = splittedDate?.[1]?.split("-")?.[0];

  returnVal = splittedDate?.[0] + "T" + time;

  return returnVal;
};

const getFullDateStr = (date) => {
  let year;
  let month;
  let dateOfMonth;
  if (typeof date === "string") {
    const splittedDate = date?.split("T")?.[0];
    year = parseInt(splittedDate?.split("-")?.[0]);
    month = parseInt(splittedDate?.split("-")?.[1]);
    dateOfMonth = parseInt(splittedDate?.split("-")?.[2]);
  } else {
    year = date?.getFullYear?.();
    month = date?.getMonth?.();
    dateOfMonth = date?.getDate?.();
  }

  return `${year}-${month}-${dateOfMonth}`;
};

const getTSeparatedDate = (date) => {
  return `${date?.getFullYear()}-${formatTimeUnits(
    date?.getMonth?.() + 1,
  )}-${formatTimeUnits(date?.getDate())}T${formatTimeUnits(
    date?.getHours(),
  )}:${formatTimeUnits(date?.getMinutes())}:${formatTimeUnits(
    date?.getSeconds(),
  )}`;
};

const dashSeparatedDateStrHandler = (date) => {
  const splittedDate = date?.split?.("/");
  return `${splittedDate?.[2]}-${splittedDate?.[1]}-${splittedDate?.[0]}T`;
};

const getSmallerOfTwoDates = ({ dt1, dt2 }) => {
  if (!dt1 || !dt2) {
    return null;
  }

  if (dt1 <= dt2) {
    return dt1;
  } else {
    return dt2;
  }
};

const getSlashSeparatedDateStrFromDateObj = (date) => {
  const dateOfMonth = date?.getDate?.();
  const month = date?.getMonth?.() + 1;
  const year = date?.getFullYear?.();

  return `${dateOfMonth < 10 ? `0${dateOfMonth}` : dateOfMonth}/${
    month < 10 ? `0${month}` : month
  }/${year}`;
};

const setTimeToZero = (date) => {
  date?.setHours?.(0);
  date?.setMinutes?.(0);
  date?.setSeconds?.(0);
  date?.setMilliseconds?.(0);

  return date;
};

const getTimeAndDateString = (date) => {
  const options = {
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };
  const formattedTime = new Date(date).toLocaleDateString("en-US", options);
  return formattedTime;
};

const isDateTimeAmOrPm = ({ dateTime }) => {
  const time = dateTime?.split?.("T")?.[1];
  const hour = Number(time?.split?.(":")?.[0]);

  if (hour <= 12) {
    return 0;
  } else {
    return 1;
  }
};

function convertTo24Hour(timeStr) {
  const regex = meridianHoursRegex;
  const match = timeStr.match(regex);

  if (match) {
    let hour = parseInt(match[1], 10); // Extract hour
    let minutes = match[2]; // Extract minutes
    let meridian = match[4].toUpperCase(); // Extract AM/PM

    // Convert to 24-hour format
    if (meridian === "AM") {
      hour = hour === 12 ? 0 : hour; // 12 AM -> 00, others stay the same
    } else {
      hour = hour === 12 ? 12 : hour + 12; // 12 PM stays 12, others add 12
    }

    return `${hour.toString().padStart(2, "0")}:${minutes}`; // Format HH:MM
  }

  return "Invalid time format";
}

const compactAMPMTimeRegexTo24HourFormat = (timeStr) => {
  const match = timeStr.match(compactAMPMTimeRegex);

  if (!match) return null; // Invalid format

  let hours = parseInt(match[1], 10);
  let minutes = match[2] ? match[2] : "00"; // Default to "00" if no minutes provided
  const period = match[3].toLowerCase();

  if (period === "p" && hours !== 12) {
    hours += 12;
  } else if (period === "a" && hours === 12) {
    hours = 0;
  }

  return `${String(hours).padStart(2, "0")}:${minutes}`;
};

const convertShortYearToFull = (dateStr) => {
  const regex = dateRegex3;

  if (!regex.test(dateStr)) return null; // Return null if format is invalid

  return dateStr.replace(regex, (_, month, day, year) => {
    // Ensure month and day are two digits
    const formattedMonth = month.padStart(2, "0");
    const formattedDay = day.padStart(2, "0");

    // Ensure year is always 4 digits (assumes 2000-2049, otherwise 1900-1999)
    const fullYear = parseInt(year, 10) < 50 ? `20${year}` : `19${year}`;

    return `${formattedMonth}/${formattedDay}/${fullYear}`;
  });
};

const convertToISOFormat = (dateStr) => {
  const regex = dateRegex2;

  if (!regex.test(dateStr)) return null; // Return null if format is invalid

  return dateStr.replace(regex, (_, month, day, year) => {
    // Ensure month and day are two digits
    const formattedMonth = month.length === 1 ? `0${month}` : month;
    const formattedDay = day.length === 1 ? `0${day}` : day;

    return `${year}-${formattedMonth}-${formattedDay}`;
  });
};

/**
 * Normalizes a time value to 'YYYY-MM-DDTHH:mm:ss' format.
 * If already in that format, returns unchanged.
 *
 * @param {string | number | Date | dayjs.Dayjs} input - The input to normalize.
 * @returns {string | null} - Formatted string or null if invalid.
 */
const normalizeToDateTimeString = (input) => {
  const FORMAT = "YYYY-MM-DDTHH:mm:ss";

  // Helper to check if already in correct format
  const isFormatted = (val) => {
    return typeof val === "string" && dayjs(val, FORMAT, true).isValid();
  };

  // If already in format, return it
  if (isFormatted(input)) {
    return input;
  }

  // Attempt conversion
  const date = dayjs(input);
  return date.isValid() ? date.format(FORMAT) : null;
};

/**
 * Formats a date according to the specified format pattern.
 * Accepts Date object or date string.
 *
 * @param {Date | string} date - The date to format
 * @param {string} format - Format pattern (default: "MM/DD/YYYY")
 *                          Supported tokens: YYYY, YY, MM, M, DD, D
 * @returns {string} - Formatted date string, or empty string if invalid
 * @example
 * formatDate(new Date(), "MM/DD/YYYY") // "12/13/2025"
 * formatDate("2025-12-13", "DD-MM-YYYY") // "13-12-2025"
 * formatDate(new Date(), "YYYY/MM/DD") // "2025/12/13"
 */
const formatDate = (date, format = "MM/DD/YYYY") => {
  if (!date) return "";

  const dateObj = typeof date === "string" ? new Date(date) : date;
  
  if (isNaN(dateObj.getTime())) return "";

  const year = dateObj.getFullYear();
  const month = dateObj.getMonth() + 1;
  const day = dateObj.getDate();

  const tokens = {
    YYYY: String(year),
    YY: String(year).slice(-2),
    MM: String(month).padStart(2, "0"),
    M: String(month),
    DD: String(day).padStart(2, "0"),
    D: String(day),
  };

  return format.replace(/YYYY|YY|MM|M|DD|D/g, (match) => tokens[match]);
};

export {
  getFormattedTimeUnit,
  getUTCTimestampFromDate,
  getFullDateWithTime,
  getFullDate,
  getFormattedFullDate,
  createDateFromDateString,
  convertFromGivenTimezoneToUTC,
  convertFromUTCToGivenTimezone,
  getFullDateStr,
  getTSeparatedDate,
  formatAMPM,
  dashSeparatedDateStrHandler,
  getSmallerOfTwoDates,
  getSlashSeparatedDateStrFromDateObj,
  setTimeToZero,
  getTimeAndDateString,
  isDateTimeAmOrPm,
  convertTo24Hour,
  convertShortYearToFull,
  convertToISOFormat,
  compactAMPMTimeRegexTo24HourFormat,
  normalizeToDateTimeString,
  formatDate,
};